import { ArrowRight, ChevronRight, Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';

import { CreateSegment } from './components';

import { Button } from 'components/ui/button';
import { useSidebar } from 'features/providers/SidebarProvider/SidebarProvider';
import { selectCreateOrder } from 'features/store/slices/createOrder';
import { useActions, useAppSelector } from 'features/hooks/useRedux';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'components/ui/select';

export const Header = () => {
  const { toggle } = useSidebar();

  const { order, isCreationProgress } = useAppSelector(selectCreateOrder);
  const { updateChannels, setIsCreationProgressOrder } = useActions();

  const handleNextClick = () => {
    setIsCreationProgressOrder(true);
  };

  return (
    <header className="h-[60px] sticky top-0 z-10 bg-white border-b">
      <div className="flex items-center justify-between h-16 px-4 mx-auto">
        {order.channels.length > 0 && !isCreationProgress ? (
          <div className="flex items-center justify-between w-full">
            <div className="flex items-center gap-4"></div>
            <div className="flex items-center gap-2">
              <CreateSegment />
              <Button size={'sm'} variant="outline" onClick={() => updateChannels([])}>
                <X />
              </Button>
              <Link to={`/create_order`}>
                <Button size={'sm'} onClick={handleNextClick}>
                  Далее
                </Button>
              </Link>
            </div>
          </div>
        ) : (
          <>
            <div className="flex items-center gap-4">
              <Button variant="outline" size="icon" className="lg:!hidden" onClick={toggle}>
                <Menu className="w-4 h-4" />
              </Button>
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 32 32">
                    <path
                      fill="#59C9F9"
                      d="M16 .5C7.437.5.5 7.438.5 16S7.438 31.5 16 31.5c8.563 0 15.5-6.938 15.5-15.5S24.562.5 16 .5m7.613 10.619l-2.544 11.988c-.188.85-.694 1.056-1.4.656l-3.875-2.856l-1.869 1.8c-.206.206-.381.381-.781.381l.275-3.944l7.181-6.488c.313-.275-.069-.431-.482-.156l-8.875 5.587l-3.825-1.194c-.831-.262-.85-.831.175-1.231l14.944-5.763c.694-.25 1.3.169 1.075 1.219z"
                    />
                  </svg>
                  <h1 className="text-sm font-semibold md:text-xl">Telegram</h1>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <Select defaultValue="ru">
                <SelectTrigger className="w-[80px] md:w-[120px]">
                  <SelectValue placeholder="Language" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="ru">Русский</SelectItem>
                  <SelectItem value="uz">Узбекский</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </>
        )}
      </div>
    </header>
  );
};
